import React, { Component } from 'react';
import  AuthService  from "../api/authentication.js";
import {
    Link,
  } from 'react-router-dom'
  const Auth = new AuthService();
class Moble extends Component {
    logout=(event)=>{
        event.preventDefault();
        Auth.logout()
       this.props.logout()
    }
    
    
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
            <div className="Home"> 
                <div>
                {
                    this.props.disableLink  === undefined ? 
                     <ul className="dashboard-ul-body-moble">
                        <li className=" dashboard-i-paralink">
                        <Link to="/dashboard" className={this.props.isActiveD? 'button is-focused' : "button is-success"}><i className="fas fa-tachometer-alt"></i></Link>
                        </li>
                        <li>
                        <Link to="/activity"   className={this.props.isActive ? 'button is-focused' : "button is-success"}><i className="far fa-money-bill-alt "></i></Link>
                        </li>
                        <li>
                        <Link to="/event/new" className={this.props.isActiveE ? 'button is-focused' : "button is-success"}><i className=" fab fa-wpforms icon-link"></i></Link>
                        </li>
                        <li>
                        <Link  to="/events"  className={this.props.isActiveF ? 'button is-focused' : "button is-success"} ><i className="fas fa-clipboard-list icon-link"></i></Link>
                        </li>
                        {/* <li>
                        <Link to="/notification" className="button is-success"><i className="far fa-newspaper "></i></Link>
                        </li> */}
                        <li>
                        <Link to="/setting" className={this.props.isActiveS ? 'button is-focused' : "button is-success"}><i className="fas fa-user-cog "></i></Link>
                        </li>
                        <li>
                        <a className="button is-danger" onClick={this.logout}><i className="fas fa-sign-out-alt"></i></a>
                        </li>
                     </ul>

                     :

                     <ul className="dashboard-ul-body-moble">
                     <li className=" dashboard-i-paralink">
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="fas fa-tachometer-alt"></i></a>
                     </li>
                     <li>
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="far fa-money-bill-alt "></i></a>
                     </li>
                     <li>
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="   fas fa-graduation-cap "></i></a>
                     </li>
                     <li>
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="far fa-newspaper "></i></a>
                     </li>
                     <li>
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="fas fa-user-cog "></i></a>
                     </li>
                     <li>
                     <a className="button is-success" style={{ cursor: 'not-allowed'}}><i className="fas fa-sign-out-alt"></i></a>
                     lkxgk
                     </li>
                  </ul>

                }
                   </div>

                

           </div>     

    )

}





}

export default Moble;


// WEBPACK FOOTER //
// ./src/component/sidenav/moble.js